import { isExpectedAuthenticationFailure } from '~/utils/authenticationFailure'

export const isHttpResponseError = error => Boolean(error?.response)

export const shouldPropagateHttpFailure = error => {
	if (!isHttpResponseError(error)) {
		return false
	}

	return (
		error.response?.status === 401 || isExpectedAuthenticationFailure(error)
	)
}

/**
 * Recover from API failures that the global axios interceptor already surfaced
 * (toast + rejected promise). Use only on read paths whose success handlers
 * destructure the response; mutations must reject so callers can avoid false
 * success UX.
 *
 * Authentication failures (401) always propagate so session recovery can run.
 */
export const withHandledHttpFailure = (promise, fallback = undefined) =>
	promise.catch(error => {
		if (shouldPropagateHttpFailure(error)) {
			throw error
		}

		if (isHttpResponseError(error)) {
			return fallback
		}

		throw error
	})
